<app-single-page />

<ng-template #template_details>
    <app-login-details 
        (onEscape)="emit_onEscape();"
        (onPageLoaded)="emit_onPageLoaded()"
        [autofocus]="true"
    />
</ng-template>
